export default __webpack_public_path__ + "static/media/point-status-2.9bacd491.svg";